import moment from 'moment-timezone';
import { Component, Vue } from 'vue-property-decorator';
import StringUtils from '@/utils/StringUtils';

@Component
/**
 * Calander를 그리는 로직이 담긴 Mixin
 */
export default class DateMixin extends Vue {

    protected readonly YEAR_MIN: number = 1800;
    protected readonly YEAR_MAX: number = 10;
    protected readonly MONTH_MAX: number = 12;
    protected readonly MONTH_MIN: number = 1;

    protected readonly CALENDAR_MIN_COLUMN: number = 1;
    protected readonly CALENDAR_MAX_COLUMN: number = 7;

    protected readonly POSSIBLE_FORMATS: string[] = ['YYYY', 'YYYYMM', 'YYYYMMDD', 'YYYYMMDDHHmmss', 'YYYYMMDDHHmmssZZ'];
    protected readonly DATE_FORMATS: string[] = ['YYYY', 'YYYYMM', 'YYYYMMDD'];
    protected readonly DATETIME_FORMATS: string[] = ['YYYYMMDDHHmmss', 'YYYYMMDDHHmmssZZ'];
    protected readonly UK_FORMATS: string[] = ['YYYY', 'YYYYMM'];
    protected readonly TIME_FORMAT: string = 'HHmmss';
    protected readonly DATETIME_FORMAT: string = 'YYYYMMDDHHmmss';
    protected readonly TIME_ZONE_FORMAT: string = 'YYYYMMDDHHmmssZZ';

    protected readonly SUNDAY_FONT_COLOR: string = '#fa2710';

    protected currentYear: number = parseInt(moment().tz(this.getTimezone()).format('YYYY'), 10);
    protected currentMonth: number = parseInt(moment().tz(this.getTimezone()).format('MM'), 10);
    protected currentDay: number = parseInt(moment().tz(this.getTimezone()).format('DD'), 10);

    protected today: any = moment().tz(this.getTimezone()).format('YYYYMMDD');

    protected visible: boolean = false;
    protected dayClass: [] = [];

    get getDaysInMonth(): number[] {
        const daysInMonth = moment(`${this.currentYear}-${this.currentMonth}`, 'YYYY-MM').daysInMonth();
        return Array.from({length: daysInMonth}, (v, k) => k + 1);
    }

    get disabledMonth() {
        return ((month: number) => {
            if (moment(this.today).year() > this.currentYear) {
                return false;
            }
            return month > 1 + moment(this.today).month();
        });
    }

    public getTimezone() {
        return this.$route.meta.isAdmin ? 'Asia/Seoul' : this.$store.getters.getTimeZone;
    }

    public getMaxYear(minYear: number, maxYear: number = 0) {
        return moment(this.today).year() - minYear + maxYear;
    }

    public getYear(index: number, maxYear: number = 0) {
        return this.getMaxYear(this.YEAR_MIN, maxYear) - index + this.YEAR_MIN;
    }

    public getDay(trIndex: any, tdIndex: any): number {
        return this.getDaysInMonth[(7 * trIndex) +
        (tdIndex - this.getDayInWeekend(this.currentYear, this.currentMonth, 1))];
    }

    public getDayInWeekend(year: any, month: any, date: any): number {
        return moment(`${year}-${month}-${date}`, 'YYYY-MM-DD').weekday();
    }

    public getCurrentDateByFormat(format: string): string {
        return moment().format(format);
    }

    public getDateByFormat(format: string, year: any, month?: any, date?: any): string {
        const monthString = month ? `, ${month}` : '';
        const dateString = date ? `, ${date}` : '';

        return moment(`${year}${monthString}${dateString}`, format).format(format);
    }

    public getWeekdayHeaderStyle(): any {
        return { 'text-align': 'center' };
    }

    public getMaxWeekInMonth(): number {
        // 현재 month의 firstDay, lastDay를 구하기 위한 기준 날짜
        const currentDate = this.getDateByFormat('YYYY-MM-DD', this.currentYear, this.currentMonth, 1);
        const firstDay = moment(currentDate).date(1);
        const lastDay = moment(currentDate).date(moment(currentDate).daysInMonth());
        const startWeek = firstDay.week();
        const endWeek = lastDay.week();

        if (endWeek < startWeek) {
            return firstDay.weeksInYear() - startWeek + 1 + endWeek;
        } else {
            return endWeek - startWeek + 1;
        }
    }

    public getCommonDayClass(date: any, today: string, bindedDay: any, currentDate: string): any {
        const dayClass: string[] = [];

        if (bindedDay === today && bindedDay !== currentDate) {
            return [...dayClass, 'today'];
        }

        if (date !== undefined && currentDate === bindedDay) {
            return [...dayClass, 'current'];
        } else {
            return dayClass;
        }
    }

    public getDayStyle(col: any, date: any): any {
        if (!StringUtils.hasValue(date)) {
            return { cursor: 'default' };
        }

        if (col === this.CALENDAR_MIN_COLUMN) {
            return { color: this.SUNDAY_FONT_COLOR };
        } else {
            return {};
        }
    }

    public isCheckDay(trIndex: any, tdIndex: any): boolean {
        return (this.CALENDAR_MAX_COLUMN * trIndex) + tdIndex >= this.getDayInWeekend(this.currentYear, this.currentMonth, 1);
    }

    public isValidDate(date: any, formats: any): boolean {
        return StringUtils.hasValue(date) && moment(date, formats, true).isValid();
    }

    public onChangeYear(year: number) {
        this.currentYear = year;
    }

    public onChangeMonth(month: number) {
        this.currentMonth = month;
    }

    public onClickPrevYear() {
        this.currentYear -= 1;
    }

    public onClickNextYear() {
        this.currentYear += 1;
    }

    public onClickPrevMonth() {
        if (this.currentMonth === this.MONTH_MIN) {
            this.currentMonth = this.MONTH_MAX;
            this.currentYear -= 1;
            return;
        }
        this.currentMonth -= 1;
    }

    public onClickNextMonth() {
        if (this.currentMonth === this.MONTH_MAX) {
            this.currentMonth = 1;
            this.currentYear += 1;
            return;
        }
        this.currentMonth += 1;
    }
}

